import { B200, B300, B400, N30, N40, N50A, N60A } from '@atlaskit/theme/colors';
export var transitionDuration = '0.2s';
export var input = {
  height: 40
};
export var thumb = {
  size: 16,
  borderWidth: 2,
  background: {
    default: "var(--ds-background-neutral-bold, ".concat(B400, ")"),
    hovered: "var(--ds-background-neutral-bold-hovered, ".concat(B300, ")"),
    pressed: "var(--ds-background-neutral-bold-pressed, ".concat(B200, ")")
  },
  borderColor: {
    default: 'transparent',
    focused: "var(--ds-border-focused, ".concat(B200, ")")
  },
  boxShadow: {
    default: "var(--ds-UNSAFE-transparent, ".concat("0 4px 8px -2px ".concat(N50A, ", 0 0 1px ").concat(N60A), ")"),
    disabled: "var(--ds-shadow-raised, ".concat("0 0 1px ".concat(N60A), ")")
  }
};
export var track = {
  height: 4,
  /**
   * borderRadius >= height / 2 to create a pill shape.
   * Using '50%' creates an ellipse.
   */
  borderRadius: 2,
  background: {
    default: "var(--ds-background-neutral, ".concat(N30, ")"),
    hovered: "var(--ds-background-neutral-hovered, ".concat(N40, ")")
  },
  foreground: {
    default: "var(--ds-background-neutral-bold, ".concat(B400, ")"),
    hovered: "var(--ds-background-neutral-bold-hovered, ".concat(B300, ")")
  }
};